import React from 'react';
import { PrimaryButton } from '@fluentui/react';
import { Color } from '../../const/Const';

const ButtonDefault = (props) => {

    let vFull = {};
    if (props.full) {
        vFull = {
            width: '100%'
        }
    }

    let vBColor = {
        backgroundColor: Color.blue,
        border: '1px solid #0358A7'
    }

    if (props.disable == true) {
        vBColor = {
            backgroundColor: Color.grayButton,
            color: Color.white
        }
    }

    if (props.color) {
        vBColor = {
            backgroundColor: props.color,
            border: '1px solid ' + props.color
        }
    }

    let vHeight = {};
    if (props.height) {
        vHeight = {
            height: props.height
        };
    }

    let vIcon = {};

    if (props.icon) {
        vIcon = {
            onRenderIcon: () => {
                return (props.icon);
            }
        }
    }

    return (
        <div>
            <PrimaryButton
                disabled={props.disable == true ? true : false}
                style={{ ...vBColor, ...vFull, ...vHeight }}
                text={props.text}
                onClick={props.onClick}
                {...vIcon} />
        </div>
    );
}

export default ButtonDefault;